export const set_title = (title) => {
    document.title = `Happyfaces • social - ${title}`;
}